import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import CONFIG from '../../config';
import news from './en_news';
import projects from './en_projects';

export default Object.assign({
    FORMAT_DATE: 'm/d/Y',

    NAV_HOME: 'Home',
    NAV_ABOUT: 'INM',
    NAV_NEWS: 'News',
    NAV_PROJECTS: 'Projects',
    NAV_CONTACT: 'Contact',

    NAV_FAQ: 'FAQ',
    NAV_IMPRINT: 'Imprint',
    NAV_SITEMAP: 'Sitemap',

    FOOTER_IDL_TITLE: 'IDL - For a free Internet',
    FOOTER_SETTINGS_HEAD: 'Settings',
    FOOTER_SETTINGS_DESCRIPTION: 'Here you can customize the WikINM for yourself.',
    FOOTER_SETTINGS_OPTION_COOKIES: 'Cookies',
    FOOTER_SETTINGS_OPTION_COOKIES_ALERT: 'Currently, only cookies that are necessary for persisting the settings are saved.',
    FOOTER_MORE_LINKS_HEAD: 'More...',

    FOOTER_SUGGESTIONS: 'Suggestions',

    IMPRINT_HEAD: 'Imprint (German)',
    IMPRINT_CONTACT_HINT: <Fragment>You are welcome to contact us <Link to={CONFIG.ROUTES.CONTACT}>here</Link>.</Fragment>,

    ABOUT_INFO: <Fragment>
        <p><strong>INM</strong> is a "group", that is mainly producing <a href="https://en.wikipedia.org/wiki/Machinima" target="_blank" rel="noopener noreferrer">Machinimas</a>.</p>
        <p>
            It is a <a href="#team">team</a> of 8 people and most of their <a href="https://en.wikipedia.org/wiki/Machinima" target="_blank" rel="noopener noreferrer">Machinimas</a> are made with the multiplayer modification <a href="https://www.sa-mp.com/" target="_blank" rel="noopener noreferrer">SAMP</a> or with <a href="https://en.wikipedia.org/wiki/Grand_Theft_Auto_Online" target="_blank" rel="noopener noreferrer">Grand Theft Auto Online</a> (the online mode of <a href="https://en.wikipedia.org/wiki/Grand_Theft_Auto_V" target="_blank" rel="noopener noreferrer">Grand Theft Auto V</a>).<br />
            SAMP is a multiplayer add-on for the game <a href="https://en.wikipedia.org/wiki/Grand_Theft_Auto:_San_Andreas" target="_blank" rel="noopener noreferrer">Grand Theft Auto: San Andreas</a>.<br />
            INM videos are found on the <a href="https://www.youtube.com/user/wesoneakaINM" target="_blank" rel="noopener noreferrer">YouTube</a> video platform only.
        </p>
        <p>
            It all started on the videoplatforms <a href="https://www.myvideo.de/" target="_blank" rel="noopener noreferrer">MyVideo</a> and <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">YouTube</a>.
            As "Myth crew", INM released videos that were about the mysteries of the game <a href="https://en.wikipedia.org/wiki/Grand_Theft_Auto:_San_Andreas" target="_blank" rel="noopener noreferrer">Grand Theft Auto: San Andreas</a>.
            Also - the well known - "Alien Mythos" (alien myth).
        </p>
        <p>
            Later INM started with the first Machinima <a href={CONFIG.ROUTES.PROJECTS + '#Restless Survivors'}>Restless Survivors</a>.
        </p>
        <p>
            Because of the low user activity on <a href="https://www.myvideo.de/" target="_blank" rel="noopener noreferrer">MyVideo</a>, wesone decided to switch to <a href="https://www.youtube.com/user/wesoneakaINM" target="_blank" rel="noopener noreferrer">YouTube</a> completely and stopped further uploading to <a href="https://www.myvideo.de/" target="_blank" rel="noopener noreferrer">MyVideo</a>.
        </p>
    </Fragment>,
    ABOUT_MEMBER_DEFAULT: '-',
    ABOUT_MEMBER_wesone: <Fragment><span className="font-weight-bold">wesone</span> was born and raised in Las Venturas. He is the founder of INM and also the producer of the movies. He is responsible for the storyline, camera, the cut and the editing.</Fragment>,
    ABOUT_MEMBER_killerman: <Fragment><span className="font-weight-bold">killerman</span> grew up in the dangerous hoods of Ganton, east Los Santos. He was in jail for 4 years because of drug dealing. Then he became member of INM.</Fragment>,
    ABOUT_MEMBER_Deadwood: <Fragment><span className="font-weight-bold">Deadwood</span> lives in Bayside. In the beginning he was just a type of help but he joined the team after a short time (Deadwood and wesone were friends before).</Fragment>,
    ABOUT_MEMBER_NoX: <Fragment><span className="font-weight-bold">NoX</span> is heir to a million dollar empire and does not need to worry about money. From time to time he stands in front of the law because of car theft, drive drunk, driving without license and shooting his neighbours. But because he come up with bail just like that, this is his least problem. He works closely with wesone and is also actor and a faithful member.</Fragment>,
    ABOUT_MEMBER_SergejVodkakov: <Fragment><span className="font-weight-bold">SergejVodkakov</span> is co-founder of INM. He stays out of the story creating though and is just available for acting most of the time.</Fragment>,
    ABOUT_MEMBER_Poulsen: <Fragment><span className="font-weight-bold">Poulsen</span> and wesone are very good friends, because they grew up together in Las Venturas. That is why Poulsen joined the team after some time.</Fragment>,
    ABOUT_MEMBER_Neon: <Fragment>Well... This is <span className="font-weight-bold">Neon</span>.</Fragment>,
    ABOUT_MEMBER_Jacqui: <Fragment><span className="font-weight-bold">Jacqui</span> is the newest member of INM. She was a big fan of INM and joined the team after a long time.</Fragment>,

    NEWS_PLANNED: 'Planned Projects',

    PROJECTS_CAROUSEL_NEXT: 'Next',
    PROJECTS_CAROUSEL_PREV: 'Back',
    PROJECTS_RELEASED_ON: 'Released on',
    PROJECTS_TRIVIA: 'Trivia',

    CONTACT_NAME: 'Name',
    CONTACT_EMAIL: 'E-mail address',
    CONTACT_SUBJECT: 'Subject',
    CONTACT_MESSAGE: 'Message',
    CONTACT_SUBMIT_BUTTON: 'Submit',
    CONTACT_SUBMIT_SUCCESS: 'The message was sent successfully!',
    CONTACT_SUBMIT_FAILURE: 'The message could not be sent. Please check your input and try again.',
    CONTACT_SUBMIT_FAILURE_500: 'The server is currently overloaded. Try again later.',

    CONTACT_VALIDATION_STRING: 'Enter at least ${min} character.',
    CONTACT_VALIDATION_EMAIL: 'Enter a valid e-mail address.',
    CONTACT_VALIDATION_EMAIL_HINT: 'We need your e-mail address in order to reply.',

    CONTACT_REASON_SUGGESTION: 'Suggestion',

    FAQ_HEAD: 'Frequently Asked Questions',
    FAQ_INFO: <Fragment>
        If you cannot find an answer to your question, make sure to <strong><Link to={CONFIG.ROUTES.CONTACT}>contact us</Link></strong>.
    </Fragment>,
    FAQ_ENTRIES: [
        {
            name: 'General',
            entries: [
                [
                    'Are you still there?',
                    <Fragment>
                        <p>
                            Yes, we are still here.
                        </p>
                        <p>
                            Even if it may seem as if we have retired, Machinimas still belong to our hobbies.
                        </p>
                    </Fragment>
                ],
                [
                    'When will you release the next video?',
                    <Fragment>
                        <p>
                            Uff... There's no easy answer to that.
                            Unfortunately you do not always have enough time to invest in your hobbies.
                        </p>
                        <p>
                            Since this hobby is getting less and less attention, but you want to improve the quality of the videos constantly,
                            the time span between uploads will also increase.
                            We are sorry, but since this is really just a hobby,
                            there is currently not much that can be changed in this situation.
                        </p>
                    </Fragment>
                ],
                [
                    'How can I watch a blocked video?',
                    <Fragment>
                        <p>
                            Over the years some videos on YouTube have been blocked.
                            Until now, the reason for this was always the use of certain music titles within the videos.
                        </p>
                        <p>
                            Although (according to YouTube) these were not copyright infringements, the respective rights holders would like to restrict/revoke the availability.
                            In some cases, videos that have had their music titles replaced have been blocked again with new complaints.
                        </p>
                        <p>
                            There will be no more "reuploads".
                            However, affected music titles may be removed from videos that have already been uploaded, as YouTube now offers this function to unlock videos again.
                        </p>
                    </Fragment>
                ]
            ]
        },
        {
            name: 'Production',
            entries: [
                [
                    'How are the videos produced?',
                    <Fragment>
                        <p>
                            Once you have the idea for a video and have thought about the scenes, the first thing you need to do is record game scenes.
                            For this you can choose from different programs.
                            In Windows, for example, there is the "Windows Game Bar", with NVIDIA graphics cards you can use "NVIDIA ShadowPlay", or the classic way with the help of the "Fraps" program.
                        </p>
                        <p>
                            "Grand Theft Auto IV" and "Grand Theft Auto V" offer the possibility (for PC) of recording the game and even editing it afterwards.
                        </p>
                        <p>
                            After the recording of the game scenes, it is time to start editing. A video must be cut together from the individual scenes.
                            With video editing programs such as "MAGIX Video Deluxe" or "Sony Vegas Pro", you can live out your own creativity to the full.
                            However, there are also plenty of free alternatives that are completely sufficient.
                        </p>
                        <p>
                            When the video is ready, it can be rendered (exported) and uploaded.
                        </p>
                    </Fragment>
                ],
                [
                    'Which games are used?',
                    <Fragment>
                        <p>
                            Basically, you can make a video from any game. Some are better suited than others.
                        </p>
                        <p>
                            We started with "Grand Theft Auto: San Andreas" and also create videos with "Grand Theft Auto V".
                            In "Grand Theft Auto III", "Grand Theft Auto: Vice City" and "Grand Theft Auto IV" we have only created a few scenes that have been used in other videos so far.
                        </p>
                        <p>
                            For <Link to={CONFIG.ROUTES.PROJECTS + '#100.000 To Live Longer'}>100.000 To Live Longer</Link> a scene from "Call of Duty World at War" was recorded at the beginning.
                        </p>
                        <p>
                            A video with scenes from "Mafia II" was also planned.
                            Immersive games like "Star Citizen" or "Red Dead Redemption 2" are also suitable for Machinimas.
                        </p>
                        <p>
                            And who knows what wonderful games await us in the future?
                        </p>
                    </Fragment>
                ]
            ]
        },
        {
            name: 'SAMP',
            entries: [
                [
                    'Will the INM SAMP server go online again sometime?',
                    <Fragment>
                        <p>
                            Unfortunately, this is currently not planned.
                        </p>
                    </Fragment>
                ],
                [
                    'Are you still playing SAMP? If so, on which server(s)?',
                    <Fragment>
                        <p>
                            No, we are currently not active in SAMP.
                        </p>
                    </Fragment>
                ]
            ]
        }
    ]
}, news, projects);
